import { useContext } from "react";
import { Handle, Position } from "reactflow";
import { Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EastIcon from "@mui/icons-material/East";
import NodeDeleteContext from "./NodeDeleteContext";

const ButtonNode = (props) => {
  const { selected, data, isConnectable = true, id } = props;

  const { onNodesDelete, edges } = useContext(NodeDeleteContext);

  const hasOutgoingEdge = edges?.some((edge) => edge.source === id);
  const canConnect = isConnectable && !hasOutgoingEdge;

  const handleDelete = (event) => {
    event.stopPropagation();
    onNodesDelete([props]);
  };

  const label = data?.label || "";

  return (
    <div className="scheme-button-wrap">
      <div className="scheme-button__pill">
        {selected && (
          <DeleteIcon
            className="scheme-button-delete nodrag nopan"
            fontSize="inherit"
            onPointerDown={(event) => event.stopPropagation()}
            onClick={handleDelete}
          />
        )}
        <Tooltip title={label} placement="top" enterDelay={400}>
          <span className="scheme-button__label nodrag nopan">{label}</span>
        </Tooltip>
        <span
          className={`scheme-button__connector${
            hasOutgoingEdge ? " scheme-button__connector--linked" : ""
          }`}
          title={
            hasOutgoingEdge
              ? "Кнопка уже связана со сценой"
              : "Потяните к следующей сцене"
          }
        >
          <EastIcon fontSize="inherit" className="scheme-button__connector-icon" />
          <Handle
            type="source"
            position={Position.Right}
            id="source"
            className="scheme-button__handle"
            isConnectable={canConnect}
          />
        </span>
      </div>
    </div>
  );
};

export default ButtonNode;
